import { css } from '@emotion/react';

import { token } from '@atlaskit/tokens';

export const overflowEllipsis = (maxWidth = 'inherit') => `
  overflow: hidden;
  max-width: ${maxWidth};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const link = css({
  '&, &:hover, &:focus': {
    color: token('color.text'),
  },
});

export const subtleLink = css({
  '&, &:hover, &:focus': {
    color: token('color.text.subtlest'),
  },
});

export const fixedFlexItem = css({
  display: 'flex',
  flexShrink: 0,
  flexGrow: 0,
});
